import Link from "next/link";
import HeadingComponent from "./HeadingComponent";
import { CardContainer } from "./CardContainer";

type CardSliderProps = {
  headingText: string;
  data: Array<any>;
  href: string;
  as: string;
};

const CardSlider = ({ headingText, data, href, as }: CardSliderProps) => {
  return (
    <>
      <div className="card-slider-wrapper">
        <HeadingComponent headingText={headingText} margin="16px" />
        <div className="card-slider-item-wrapper">
          {data.map((i, key) => {
            return (
              <div className="item" key={key}>
                <CardContainer
                  img={i.banner}
                  title={i.title}
                  date={i.pers_date}
                  button="Baca"
                  href={`${href}/[slug]`}
                  slug={`${as}/${i.slug}`}
                />
              </div>
            );
          })}
        </div>
        <Link href={href} as={as}>
          <a className="card-slider-more">
            <h3>Lihat Semua</h3>
          </a>
        </Link>

        <style jsx>
          {`
            .card-slider-wrapper {
              max-width: 960px;
              padding: 16px 0;
              display: flex;
              width: 100%;
              flex-direction: column;
              align-items: center;
              align-self: center;
              cursor: pointer;
            }
            .card-slider-item-wrapper {
              display: flex;
              width: 100%;
              overflow: auto;
              padding: 10px 0;
            }
            .item {
              min-width: 300px;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin: 0 8px;
            }
            .card-slider-more {
              font-weight: bold;
              margin: 16px;
              color: red;
              font-size: 15px;
              align-self: flex-end;
            }

            @media only screen and (max-width: 600px) {
              .card-slider-item-wrapper {
                width: 100vw;
                overflow: auto;
              }
              .item {
                width: 300px;
              }

              .card-slider-more {
                font-weight: bold;
                margin-bottom: 0;
                color: red;
                font-size: 15px;
                margin: 16px;
                -webkit-align-self: flex-end;
                -ms-flex-item-align: end;
                align-self: flex-end;
              }
            }
          `}
        </style>
      </div>
    </>
  );
};

export default CardSlider;
